import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  const token = localStorage.getItem('mmw_token');
  if (!user || !token) return <Navigate to="/auth" replace />;
  return children;
};

export default PrivateRoute;
